import { atom } from '@cloudio-saas/statex';

export const popupPropsAtom = atom<number>({
  path: ['ui', 'options', 'popup', 'prop', ':pageId', ':itemId', ':prop'],
  defaultValue: 0,
  // onChange: ({ value, oldValue, path }) => {
  //   if (value !== oldValue) {
  //     if (value > 200) {
  //       debugger;
  //     }
  //     console.log('popupPropsAtom', path, value, oldValue);
  //   }
  // },
});

export const popupPropsRootAtom = atom({
  path: ['ui', 'options', 'popup', 'prop', ':pageId', ':itemId'],
  defaultValue: {},
});
